import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FocusVisibleManager, useFocusVisible } from "use-focus-visible";
import { Wrapper, Claim, Link, Image } from "./logo.styles";
function LogoLink({ children, target, windowTarget }) {
    const { focusVisible, onFocus, onBlur } = useFocusVisible();
    return (_jsx(Link, Object.assign({ focusVisible: focusVisible, onFocus: onFocus, onBlur: onBlur, href: target, tabIndex: 0, target: windowTarget }, { children: children })));
}
export function Logo({ src, target, alt, language, previewId }) {
    function renderLink(children) {
        if (target) {
            return (_jsx(LogoLink, Object.assign({ windowTarget: "_self", target: target }, { children: children })));
        }
        return children;
    }
    return (_jsx(Wrapper, { children: _jsx(FocusVisibleManager, { children: renderLink(_jsxs(_Fragment, { children: [_jsx(Image, { "data-preview-id": previewId, src: src, alt: alt, "data-logo": true }), _jsx(Claim, { children: language })] })) }) }));
}
